import { type PlatformApi } from '@app/external/common/controller/platform-api';

export class WarmupDataHandler<T> {
  private readonly isSSR: boolean;
  private readonly isWarmupDataExperimentEnabled: boolean;
  private readonly loaderFn: () => Promise<T>;
  private readonly platformApi: PlatformApi;
  private readonly warmupDataKey: string;

  constructor(config: {
    isSSR: boolean;
    isWarmupDataExperimentEnabled: boolean;
    loaderFn: () => Promise<T>;
    platformApi: PlatformApi;
    warmupDataKey: string;
  }) {
    this.isSSR = config.isSSR;
    this.isWarmupDataExperimentEnabled = config.isWarmupDataExperimentEnabled;
    this.loaderFn = config.loaderFn;
    this.platformApi = config.platformApi;
    this.warmupDataKey = config.warmupDataKey;
  }

  async load(): Promise<T> {
    if (this.isSSR && this.isWarmupDataExperimentEnabled) {
      const data = await this.loaderFn();

      this.platformApi.window.warmupData.set(this.warmupDataKey, JSON.stringify(data));

      return data;
    }

    const decodedValue = WarmupDataHandler.decode<T>(
      this.platformApi.window.warmupData.get(this.warmupDataKey),
    );

    return decodedValue ?? this.loaderFn();
  }

  static decode<T>(data: string): T | undefined {
    if (!data) {
      return undefined; // Expected in Editor environments
    }

    try {
      return JSON.parse(data);
    } catch (err) {
      console.log('[WarmupDataHandler] Failed to parse', data);
      return undefined;
    }
  }
}
